import React from 'react';
import { Search, Plus, Filter } from 'lucide-react';
export function LeadFilters() {
  return <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6" data-id="element-370">
      <div className="flex-1 flex flex-col sm:flex-row gap-3" data-id="element-371">
        <div className="relative max-w-md w-full" data-id="element-372">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-373">
            <Search className="h-4 w-4 text-growthly-muted" data-id="element-374" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2 border border-white/10 rounded-md leading-5 bg-growthly-bg text-growthly-text placeholder-growthly-muted focus:outline-none focus:ring-1 focus:ring-growthly-amber focus:border-growthly-amber sm:text-[13px] transition-colors" placeholder="Buscar por nombre, decisor, teléfono... (F)" data-id="element-375" />
        </div>

        <div className="flex items-center space-x-2 overflow-x-auto pb-1 sm:pb-0 hide-scrollbar" data-id="element-376">
          <button className="btn-secondary inline-flex items-center whitespace-nowrap" data-id="element-377">
            <Filter className="w-4 h-4 mr-2 text-growthly-muted" data-id="element-378" />
            Filtros
          </button>
          <select className="block w-full pl-3 pr-8 py-2 text-[13px] border border-white/10 rounded-md focus:outline-none focus:ring-1 focus:ring-growthly-amber focus:border-growthly-amber bg-growthly-bg text-growthly-text" data-id="element-379">
            <option data-id="element-380">Prioridad (Todas)</option>
            <option data-id="element-381">ICP A</option>
            <option data-id="element-382">ICP B</option>
            <option data-id="element-383">ICP C</option>
          </select>
          <select className="block w-full pl-3 pr-8 py-2 text-[13px] border border-white/10 rounded-md focus:outline-none focus:ring-1 focus:ring-growthly-amber focus:border-growthly-amber bg-growthly-bg text-growthly-text" data-id="element-384">
            <option data-id="element-385">Estado (Todos)</option>
            <option data-id="element-386">Nuevo</option>
            <option data-id="element-387">Contactado</option>
            <option data-id="element-388">Conversación</option>
            <option data-id="element-389">Micro-acuerdo</option>
          </select>
        </div>
      </div>

      <div className="flex-shrink-0" data-id="element-390">
        <button className="btn-primary w-full sm:w-auto inline-flex items-center justify-center" data-id="element-391">
          <Plus className="w-4 h-4 mr-2" data-id="element-392" />
          Nuevo Lead{' '}
          <span className="ml-2 text-growthly-bg/70 text-[10px] border border-growthly-bg/30 rounded px-1 hidden sm:inline-block" data-id="element-393">
            N
          </span>
        </button>
      </div>
    </div>;
}